export default __webpack_public_path__ + "static/media/Paper cutting.4e9f7cc7.pdf";